module.exports = __webpack_public_path__ + "img/tgsmg.b8e637e2.png";